<script>
  import importacaoServico from '../servico';
  import { alert } from 'vue-strap';
  import ModalLiberarImportacao from '~componentes/ModalLiberarImportacao.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import RelatorioImportacao from './compartilhado/RelatorioImportacao.vue';
  
  export default {
    components: { alert, ModalLiberarImportacao, ModalArquivosSolicitacao, ModalMensagem, RelatorioImportacao },
    data() {
      return {
        carregando: true,
        importacao: {},
        permissaoLiberacao: false,
        modalLiberarImportacao: false,
        modalArquivos: false,
        modalMensagem: false,
        solicitacaoSelecionada: null,
        importacaoSelecionada: null,
        salvandoLiberacao: false,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar() {
        this.carregando = true;
        
        return importacaoServico
          .obterPorId(this.$route.params.id)
          .then(importacao => {
            this.carregando = false;

            this.importacao = importacao;
            this.permissaoLiberarImportacao();
          });
      },
      liberar() {
        $('#liberar').button('loading');
        this.modalLiberarImportacao = false;
        
        return importacaoServico
          .liberar(this.$route.params.id)
          .then(() => {
            $('#liberar').button('reset');
            
            toastr.success(`~Importação liberada com sucesso.`);
            $('body').removeClass('modal-open');

            this.$router.push({ name: 'compra.importacao' });
          })
          .catch(erro => {
            $('#liberar').button('reset');
            
            this.$mensagemErro(erro, 'Erro ao tentar liberar a importação, ou usuário não possui permissão.');
          });
      },
      retornaDataFormatada(data) {
        if (data == null) {
          return '---';
        }

        return this.$options.filters.formatarData(data) + ' às ' +
          this.$options.filters.formatarHora(data);
      },
      retornaLiberadoNaoLiberado(liberado, tipo) {
        if (liberado == null)
          if (tipo == 't')
            return 'Não liberado';       
          else
            return 'fa fa-check-circle naoLiberado';

        if (liberado > 0)
          if (tipo == 't')
            return 'Liberado';       
          else
            return 'fa fa-check-circle liberado'
        else
          if (tipo == 't')
            return 'Não liberado';       
          else
            return 'fa fa-check-circle naoLiberado';   
      },
      permissaoLiberarImportacao() {
        importacaoServico
        .permissaoLiberarImportacao(this.$route.params.id)
        .then(permissao => {

          this.permissaoLiberacao = permissao;
        })
        .catch(erro => {
          this.permissaoLiberacao = false;
        });
      },
      mostrarModalLiberarImportacao(importacao) {
        this.importacaoSelecionada = importacao;
        this.modalLiberarImportacao = true;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalLiberarImportacaoFechado() {
        this.animated = false;
        this.modalLiberarImportacao = false;
        this.importacaoSelecionada = null;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },      
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
      usuario1() {
        if (!this.importacao.importacaoLiberacao)
          return '---';

        return (this.importacao.importacaoLiberacao.usuario1) ? this.importacao.importacaoLiberacao.usuario1.nome : '---';
      },
      usuario2() {
        if (!this.importacao.importacaoLiberacao)
          return '---';

        return (this.importacao.importacaoLiberacao.usuario2) ? this.importacao.importacaoLiberacao.usuario2.nome : '---';
      },
      usuario3() {
        if (!this.importacao.importacaoLiberacao)
          return '---';

        return (this.importacao.importacaoLiberacao.usuario3) ? this.importacao.importacaoLiberacao.usuario3.nome : '---';
      },
      usuarioImportacao() {
        if (!this.importacao.importacaoLiberacao)
          return '---';

        return (this.importacao.importacaoLiberacao.usuarioImportacao) ? this.importacao.importacaoLiberacao.usuarioImportacao.nome : '---';
      }
    },
    mounted() {
      this.$root.botaoAcaoMostrar = false;
      this.$root.tituloDaPagina = 'Liberação de importações - Relatório';
      this.carregar(); 
      this.modalLiberarImportacao = false;
    },
  }
</script>

<style scoped>
  .liberado {
    font-size: 1.35em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .naoLiberado {
    font-size: 1.35em;
    color: #f5f5f5;
    margin-right: 3px;
  }
</style>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <modal-liberar-importacao :mostrar="modalLiberarImportacao"
                            :id="importacaoSelecionada ? importacaoSelecionada.idImportacao : ''"
                            :salvando="salvandoLiberacao"
                            @fechado="modalLiberarImportacaoFechado"
                            @liberar="liberar">
    </modal-liberar-importacao>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoImportacao : ''"
                                tipo="importacao"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoImportacao : ''"
                    tipo="SolImportacao"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando">
              <relatorio-importacao :importacao="importacao">
              </relatorio-importacao>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-1">
                  <dt>Liberação</dt>
                </dl>
                <dl class="col-xs-1">
                  <dt>LI</dt>
                </dl>
                <dl class="col-xs-2">
                  <dt>Data liberação</dt>
                </dl>
                <dl class="col-xs-4">
                  <dt>Usuário liberação</dt>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 1</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(importacao.importacaoLiberacao ? importacao.importacaoLiberacao.idUsuarioNivel1 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(importacao.importacaoLiberacao ? importacao.importacaoLiberacao.idUsuarioNivel1 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (importacao.importacaoLiberacao)  !== null ?  this.retornaDataFormatada(importacao.importacaoLiberacao.dataHoraLiberacaoNivel1) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{  this.usuario1()  }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 2</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(importacao.importacaoLiberacao ? importacao.importacaoLiberacao.idUsuarioNivel2 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(importacao.importacaoLiberacao ? importacao.importacaoLiberacao.idUsuarioNivel2 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (importacao.importacaoLiberacao)  !== null ?  this.retornaDataFormatada(importacao.importacaoLiberacao.dataHoraLiberacaoNivel2) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuario2()   }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 3</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(importacao.importacaoLiberacao ? importacao.importacaoLiberacao.idUsuarioNivel3 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(importacao.importacaoLiberacao ? importacao.importacaoLiberacao.idUsuarioNivel3 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (importacao.importacaoLiberacao)  !== null ?  this.retornaDataFormatada(importacao.importacaoLiberacao.dataHoraLiberacaoNivel3) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuario3()  }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Importação</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(importacao.importacaoLiberacao ? importacao.importacaoLiberacao.idUsuarioImportacaoLiberada : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(importacao.importacaoLiberacao ? importacao.importacaoLiberacao.idUsuarioImportacaoLiberada : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (importacao.importacaoLiberacao)  !== null ?  this.retornaDataFormatada(importacao.importacaoLiberacao.dataImportacaoLiberada) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuarioImportacao() }}</dd>
                </dl>
              </div>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <div class="text-center">

                  <button type="button"
                          class="btn btn-success"
                          v-tooltip="'Enviar mensagem'"
                          @click="mostrarModalMensagem(importacao.solicitacaoImportacao)"
                          v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolImportacao)">
                    <i class="fa fa-comment"></i> Mensagens
                  </button>

                  <button type="button"
                          class="btn btn-info"
                          v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                          @click="mostrarModalArquivos(importacao.solicitacaoImportacao)"
                          v-if="configuracao.usarArquivosSolicitacaoImportacao">
                    <i class="fa fa-archive"></i> Arquivos
                  </button>

                  <button v-if="permissaoLiberacao"
                          class="btn btn-primary"
                          v-tooltip="'Liberar importação'"
                          @click="mostrarModalLiberarImportacao(importacao)">
                    <i class="fa fa-check"></i> Liberar importação
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/importacao/componentes/Relatorio.vue